import Struct from "@yume-chan/struct";
import { ScrcpyClientForwardConnection, ScrcpyClientReverseConnection } from "../connection.js";
import { ScrcpyInjectScrollControlMessage1_16 } from "./1_16/index.js";
import { ScrcpyOptions1_21 } from "./1_21.js";
export const ScrcpyInjectScrollControlMessage1_22 = new Struct()
    .fields(ScrcpyInjectScrollControlMessage1_16)
    .int32("buttons");
export class ScrcpyOptions1_22 extends ScrcpyOptions1_21 {
    constructor(init) {
        if (init.rawVideoStream) {
            // Set implied options for client-side processing
            init.sendDeviceMeta = false;
            init.sendFrameMeta = false;
            init.sendDummyByte = false;
        }
        super(init);
    }
    getDefaultValue() {
        return Object.assign(Object.assign({}, super.getDefaultValue()), { downsizeOnError: true, sendDeviceMeta: true, sendDummyByte: true, rawVideoStream: false });
    }
    createConnection(device) {
        var _a, _b, _c;
        const defaultValue = this.getDefaultValue();
        const options = {
            control: (_a = this.value.control) !== null && _a !== void 0 ? _a : defaultValue.control,
            sendDummyByte: (_b = this.value.sendDummyByte) !== null && _b !== void 0 ? _b : defaultValue.sendDummyByte,
            sendDeviceMeta: (_c = this.value.sendDeviceMeta) !== null && _c !== void 0 ? _c : defaultValue.sendDeviceMeta,
        };
        if (this.value.tunnelForward) {
            return new ScrcpyClientForwardConnection(device, options);
        }
        else {
            return new ScrcpyClientReverseConnection(device, options);
        }
    }
    serializeInjectScrollControlMessage(message) {
        return ScrcpyInjectScrollControlMessage1_22.serialize(message);
    }
}
//# sourceMappingURL=1_22.js.map